<!-- src/components/HeaderComponent.vue -->
<template>
  <header
    class="navbar bg-base-100 shadow-md px-3 sm:px-6 flex items-center justify-between overflow-visible min-h-14 sm:min-h-16"
  >
    <!-- 햄버거 토글 (작게) -->
    <label for="drawer-left" class="btn btn-ghost lg:hidden p-2 mr-2 sm:mr-4" aria-label="메뉴 열기">
      <span class="text-xl" aria-hidden="true">☰</span>
    </label>

    <!-- 로고 -->
    <router-link to="/" class="flex items-center gap-2 min-w-0">
      <img src="@/assets/dokhublogo.png" alt="" class="h-8 w-auto logo-anim" />
      <span class="text-lg sm:text-xl font-bold whitespace-nowrap">독허브</span>
    </router-link>

    <!-- 가운데 빈 공간 확보 -->
    <div class="flex-1"></div>

    <!-- 우측: 업데이트 호버 영역 -->
    <div
      class="relative hidden sm:block"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
    >
      <span class="text-sm font-medium cursor-pointer hover:text-primary">
        업데이트
      </span>

      <!-- hover 시에만 보이는 팝업 -->
      <div
        v-if="hover"
        class="absolute right-0 top-full mt-2 w-64 bg-white text-gray-800 p-4 rounded-lg shadow-lg z-50"
      >
        <h3 class="font-semibold mb-2">1.0 업데이트</h3>
        <ul class="list-disc list-inside text-sm space-y-1">
          <li>클립 제공화면 변경</li>
          <li>바로가기 아이콘 추가</li>
          <li>독채팅 아이콘 위치변경</li>
          <li>클립 정렬방식 변경</li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue'
defineProps({ theme: String })

// hover 상태 관리
const hover = ref(false)
</script>
